import { PublicationStatus } from "@bvhi/backend-api";
import { Chip, ChipProps, SxProps } from "@bvhi/ui-base";
import { useTranslation } from "react-i18next";

interface Props {
  status: string;
  size?: "small" | "medium";
  sx?: SxProps;
}

export function PlatformCatalogPublicationStatusChip({ status, size = "small", sx }: Props) {
  const { t } = useTranslation(["enums"]);

  let label = "";
  let color: ChipProps["color"] = "default";
  switch (status) {
    case PublicationStatus.DELETED:
      label = t("enums:enums.user.status.deleted");
      color = "error";
      break;
    case PublicationStatus.DRAFT:
      label = t("enums:enums.platform.catalog.status.chip.draft");
      color = "warning";
      break;
    case PublicationStatus.PUBLISHED:
      label = t("enums:enums.platform.catalog.status.chip.published");
      color = "success";
      break;
  }

  return <Chip color={color} label={label} size={size} sx={{ ...sx }} />;
}
